import { useRouter } from 'next/navigation';
import { resetIdentifier } from '../../utils/identifier';
import { useAppSelector } from '../../redux-hooks';
import { participationIdentityModeSelector } from '../../selectors';
import { usePresentationState } from '../../presentation-state';

export const useVoteAgain = (voteKey: string) => {
  const router = useRouter();

  const participationIdentityMode = useAppSelector(
    participationIdentityModeSelector,
  );
  const { setParticipantIdentity } = usePresentationState();

  return function voteAgain() {
    resetIdentifier();

    if (participationIdentityMode === 'identified') {
      setParticipantIdentity({ status: 'needs_identification' });
    }

    router.push(`/${voteKey}`);
  };
};
